import {Component, Input, OnChanges} from '@angular/core';
import {routesNames} from '@app/app-routing.module';
import {NoStockService} from '@app/presentation/services/no-stock/no-stock.service';
import {PopupDispatcher} from '../errors/popup.dispatcher';
import {AddPromotionToCartButtonViewModel} from './add-promotion-to-cart-button.view-model';
import {LocalizedRouter} from "@app/presentation/services/localized-router";

@Component({
  selector: 'app-add-promotion-to-cart-button',
  templateUrl: './add-promotion-to-cart-button.component.html',
  styleUrls: ['./add-promotion-to-cart-button.component.scss'],
  providers: [AddPromotionToCartButtonViewModel]
})
export class AddPromotionToCartButtonComponent implements OnChanges {

  @Input() promotionCode?: string;
  @Input() size: 'small' | 'large' = 'small';
  @Input() price?: number;

  isLogged$ = this.viewModel.isLoggedIn$;
  isPriceHidden$ = this.viewModel.isPriceHidden$;
  isAdded$ = this.viewModel.isAdded$;

  isAddPromotionToCartLoading$ = this.viewModel.isAddPromotionToCartLoading$;

  constructor(
    private viewModel: AddPromotionToCartButtonViewModel,
    private popupDispatcher: PopupDispatcher,
    private noStockService: NoStockService,
    private localizedRouter: LocalizedRouter
  ) {
    this.popupDispatcher.setNotifier(viewModel.notifier);
    this.viewModel.notEnoughStock$.subscribe({
      next: products => this.noStockService.display(products)
    });
  }

  ngOnChanges(): void {
    this.getPromotionAdded();
  }

  addPromotionToCart(): void {
    if (this.promotionCode) {
      this.viewModel.addPromotionToCart(this.promotionCode);
    }
  }

  removePromotionFromCart(): void {
    if (this.promotionCode) {
      this.viewModel.removePromotionFromCart(this.promotionCode);
    }
  }

  goToLogin() {
    this.localizedRouter.navigate(['/', routesNames.login])
  }

  private getPromotionAdded(): void {
    if (this.promotionCode) {
      this.viewModel.isPromotionAdded(this.promotionCode);
    }
  }

}
